const getEnvName = () => {
  if (isDevMode) {
    return getDevSettings().host;
  }
  const host = window.location?.host;
  if (typeof host !== 'string') {
    return 'prod';
  }
  if (host.includes('test3')) {
    return 'test3';
  }
  if (host.includes('test1')) {
    return 'test1';
  }
  if (host.includes('staging1')) {
    return 'staging1';
  }
  if (host.includes('two.staging2')) {
    return 'staging22';
  }
  if (host.includes('three.staging2')) {
    return 'staging23';
  }
  if (host.includes('staging2')) {
    return 'staging2';
  }
  if (host.includes('localhost')) {
    return 'dev';
  }
  if (host.includes('schulung1')) {
    return 'schulung1';
  }
  return 'prod';
};

const isDevMode = process.env.NODE_ENV === 'development';

export const getDevSettings = () => {
  if (isDevMode) {
    return {
      host: 'dev',
      headers: {
        Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6InJ0c0ZULWItN0x1WTdEVlllU05LY0lKN1ZuYyIsImtpZCI6InJ0c0ZULWItN0x1WTdEVlllU05LY0lKN1ZuYyJ9.eyJhdWQiOiJhcGk6Ly9kZDYzNGY5Yy03ZjcxLTRiNGQtOTc3Yy1jMTVhYjAyNzQxNGUiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC85MjNkZDhiMy0zZjc0LTQ3MGQtYmU3YS01NjY4OWFkY2UyMDMvIiwiaWF0IjoxNzY0ODYwNjc1LCJuYmYiOjE3NjQ4NjA2NzUsImV4cCI6MTc2NDg2NTk3NywiYWNyIjoiMSIsImFpbyI6IkFVUUF1LzhhQUFBQTYzQjgxODZLaGhEY2xzeERCRzV6Zm5LKzZMdjFWLzF4cmMzSTRsVkhCaHpubDRmcmVOdXE3TWN4OTNwcjB6Z3BxNjc5UjFDbjZXaERTdHA3dFYvbTZ3PT0iLCJhbXIiOlsicHdkIl0sImFwcGlkIjoiNjEzNGU2NjktYmM4MS00ZTgxLWIxOTItMzM3ZjhiODM4MmM3IiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJRQTIiLCJnaXZlbl9uYW1lIjoiQXBwIiwiaXBhZGRyIjoiMjEzLjE4Ny43Ny44MSIsIm5hbWUiOiJBcHAgUUEyIiwib2lkIjoiNDBhZjBkNDMtN2ZhZC00YWFhLWE2OTgtMDYyMmU4YjEwNDk1IiwicmgiOiIxLkFUd0FzOWc5a25RX0RVZS1lbFpvbXR6aUE1eFBZOTF4ZjAxTGwzekJXckFuUVU2N0FlazhBQS4iLCJzY3AiOiJTYWxlc0FwcC5BY2Nlc3MiLCJzaWQiOiIwMDk5ODhjOS1hOGRjLWJjZjUtNTU2Yi1hZDU0MjU0N2E1N2QiLCJzdWIiOiJ6Q05aWGlIYlc0S2l1cUtJRGFsQzN1aEI5ck9zNUJtbGNvMnlPZnRaM3hRIiwidGlkIjoiOTIzZGQ4YjMtM2Y3NC00NzBkLWJlN2EtNTY2ODlhZGNlMjAzIiwidW5pcXVlX25hbWUiOiJhcHAucWEyQGVrZC1zb2xhci5kZSIsInVwbiI6ImFwcC5xYTJAZWtkLXNvbGFyLmRlIiwidXRpIjoiZkFTMTh0c21NMHVCTUlOOTRlUUJBQSIsInZlciI6IjEuMCIsInhtc19mdGQiOiIzRmlRcC1Ga3BBNlUxVmszd1pYTTU2NEo5YldSa3lQWmpkRmF4RlVBSnNNQlpYVnliM0JsYm05eWRHZ3RaSE50Y3cifQ.XknngiUZMWJ8glfmK_GpQCjQPzz9fcPrFKB8tKUyLDRBaltTVppRiYP4F_wr8ix0h5LbbJxbEjG1E2ertVv988--PrjG0FxkYz1IQObWAWRdBlvgcGsq6QFgjInQOUgmvpHTbyyDhip0f4KgduCe8d6uPRifUysaDDQGfgz3vyv2WyyjpYP17aySkO0JePXucH1g8jEVbbzroA2Vvb_bsMkAMIj_UgidAF-XCr7lOcUGOWb1GkPgtyRAWQsm6HUDxfMSi5TR1Rffa1QV1xcRToBYHb7yxLZCguV_vkUdkrBdUclsq19r_2V49S8KMlVfDY0-iW04D_jf3zC09J7Fsg`,
      },
      leadId: 1505283,
      specialRoofCoverings: ['Pappdocken', 'Schiefer'],
    };
  }
  return {};
};

export const reactStrictMode = false;

const envName = getEnvName();

const salesBackendBaseUrl = {
  test1: 'https://sales-api.test1.leads-middleware.de',
  test3: 'https://sales-api.test3.leads-middleware.de',
  staging1: 'https://sales-api.staging1.leads-middleware.de',
  staging2: 'https://sales-api.staging2.leads-middleware.de',
  staging22: 'https://sales-api.two.staging2.leads-middleware.de',
  staging23: 'https://sales-api.three.staging2.leads-middleware.de',
  schulung1: 'https://sales-api.schulung1.leads-middleware.de',
  prod: 'https://sales-backend.prod.ekd-ops.com',
  dev: 'http://localhost:8080',
} as const;

export const salesBackendApi = {
  url: salesBackendBaseUrl[envName!],
  endpoint: {
    measurementProtocolFull: 'measurementProtocol/full',
    measurementProtocolPdf: 'measurementProtocol/pdf',
    measurementProtocol: 'measurementprotocol',
    measurementProtocolRoof: 'measurementprotocolroof',
    measurementProtocolMeter: 'measurementprotocolmeter',
    measurementProtocolRoofArea: 'measurementprotocolroofarea',
    lead: 'lead',
    image: 'image',
    file: 'file',
    document: 'document',
    task: 'task',
    finishDcExpertTask: 'task/finishDcExpertTask',
  },
} as const;

const leadsMiddleWareBaseUrl = {
  test1: 'https://test1.leads-middleware.de/salesAPI/v1',
  test3: 'https://test3.leads-middleware.de/salesAPI/v1',
  staging1: 'https://staging1.leads-middleware.de/salesAPI/v1',
  staging2: 'https://staging2.leads-middleware.de/salesAPI/v1',
  staging22: 'https://two.staging2.leads-middleware.de/salesAPI/v1',
  staging23: 'https://three.staging2.leads-middleware.de/salesAPI/v1',
  schulung1: 'https://schulung1.leads-middleware.de/salesAPI/v1',
  prod: 'https://leads-middleware.de/salesAPI/v1',
  dev: 'https://staging2.leads-middleware.de/salesAPI/v1',
} as const;

export const leadsMiddlewareApi = {
  url: leadsMiddleWareBaseUrl[envName!],
  endpoint: {
    file: 'file',
  },
} as const;
